
const defaults = {
    storage: window.localStorage,
    codeVerifier: 'codeVerifier',
    codeChallenge: 'codeChallenge'
};

function fetchCodeVerifierFromLocal() {
    return defaults.storage.getItem(defaults.codeVerifier);
}

function clearCodeVerifier() {
    defaults.storage.removeItem(defaults.codeVerifier);
}

function keepCodeVerifier(codeVerifier, codeChallenge) {
    defaults.storage.setItem(defaults.codeVerifier, codeVerifier);
}

export default {
    fetchCodeVerifierFromLocal: fetchCodeVerifierFromLocal,
    clearCodeVerifier: clearCodeVerifier,
    keepCodeVerifier: keepCodeVerifier
};